import React, { FC } from "react"
import { Redirect, Route, Switch } from "react-router-dom"
import Home from "components/views/home/Home"
import { Nav } from "components/views/app/nav/Nav"
import Title from "components/views/Title"
import ProviderFinder from "components/views/providerfinder/ProviderFinder"
import SubRegion from "components/views/providerfinder/SubRegion"
import City from "components/views/providerfinder/City"
import WhatsImportant from "components/views/providerfinder/WhatsImportant"
import Transactions from "components/views/reimbursements/Transactions"
import { RequestCardContainer } from "components/containers/requestcard/RequestCardContainer"
import RequestCardSuccess from "components/views/requestcard/RequestCardSuccess"
import { FleRouter } from "../fle/FleRouter"
import AccountSettingsContainer from "../../containers/account/AccountSettingsContainer"
import ResetPasswordContainer from "../../containers/login/ResetPasswordContainer"
import ResetPasswordSuccess from "../login/ResetPasswordSuccess"
import { TalkToCarrotRouter } from "../talktocarrot/TalkToCarrotRouter"
import MerchantDeclineContainer from "../../containers/merchantdecline/MerchantDeclineContainer"
import { ServicesLoginContainer } from "../../containers/login/ServicesLoginContainer"
import { ServicesLogoutContainer } from "../../containers/logout/ServicesLogoutContainer"
import { DraggingStateContainer } from "components/views/app/DraggingStateContainer"
import { ReimbursementsRouter } from "components/views/reimbursements/ReimbursementsRouter"
import { BenefitNotStartedContainer } from "components/views/modal/BenefitNotStarted"
import { PageNotFound } from "components/views/error/PageNotFound"
import { SignatureContainer } from "../../containers/signature/SignatureContainer"
import { SignatureCompletedContainer } from "../../containers/signature/SignatureCompletedContainer"
import { LibraryRouter } from "components/containers/library/LibraryRouter"
import ActivateContainer from "../../containers/activate/ActivateContainer"
import { DigitalBenefitsGuide } from "../../../pages/digital-benefits-guide"
import { DynamicContentToggles } from "components/dynamic-content/Toggles"
import { Paths } from "../../../utils/Paths"

const App: FC = () => (
  <Switch>
    {/* Routes here are for authenticated pages that do not have side navigation */}
    <Route from="/reset-password/:guid" component={ResetPasswordContainer} />
    <Route from="/reset-password-success" component={ResetPasswordSuccess} />
    <Route path="/fle" component={FleRouter} />
    <Route path="/services/login" component={ServicesLoginContainer} />
    <Route path="/services/logout" component={ServicesLogoutContainer} />
    <Route path="/confirm/:token" component={MerchantDeclineContainer} />
    <Route exact path="/signature" component={SignatureContainer} />
    <Route exact path="/signature/completed" component={SignatureCompletedContainer} />

    <Route
      render={() => (
        <DraggingStateContainer>
          <Title />
          <Nav />
          <DynamicContentToggles />
          <BenefitNotStartedContainer />
          <Switch>
            {/* Routes here are for authenticated pages with side navigation */}
            <Route exact path="/" component={Home} />
            <Route path="/chat" component={TalkToCarrotRouter} />
            <Route path={Paths.TALK_TO_CARROT} component={TalkToCarrotRouter} />
            <Route path="/ava-bracelet" component={TalkToCarrotRouter} />
            <Redirect from="/journeywelcome" to="/" />
            <Redirect from="/journey" to="/" />
            <Redirect from="/journey/article/:id" to="/" />
            <Route path="/transactions" component={Transactions} />
            <Route path="/reimbursements" component={ReimbursementsRouter} />
            <Route exact path="/account" component={AccountSettingsContainer} />
            <Redirect from="/library" to="/read" />
            <Route path="/read" component={LibraryRouter} />
            <Redirect from="/about" to="/your-benefit-guide/about-your-benefit" />
            <Redirect from="/eligible-expenses" to="/your-benefit-guide/coverage" />
            <Redirect from="/carrot-rx" to="/your-benefit-guide/coverage/carrot-rx" />
            <Route exact path="/providerfinder" component={ProviderFinder} />
            <Route exact path="/providerfinder/:country/:subRegion" component={SubRegion} />
            <Route exact path="/providerfinder/:country/:subRegion/:city" component={City} />
            <Route exact path="/providerfinder/whatsimportant" component={WhatsImportant} />
            <Route path="/request-card/success" exact component={RequestCardSuccess} />
            <Route path="/request-card">
              <RequestCardContainer validateEligibility={true} />
            </Route>
            <Route path="/request-card-open">
              <RequestCardContainer validateEligibility={false} />
            </Route>
            <Route path={Paths.DIGITAL_BENEFITS_GUIDE} component={DigitalBenefitsGuide} />
            <Redirect exact path="/register/:guid" to={"/"} />
            <Redirect exact path="/signin" to={"/"} />
            <Redirect exact path="/signup" to={"/"} />
            <Redirect exact path="/sign-up" to={"/"} />
            <Redirect exact path="/login" to={"/"} />
            <Redirect exact path="/request-reset-password" to={"/"} />
            <Route path="/activate" component={ActivateContainer} />

            {/* 404 catch all */}
            <Route component={PageNotFound} />
          </Switch>
        </DraggingStateContainer>
      )}
    />
  </Switch>
)

export { App }
